// extracted by mini-css-extract-plugin
export default {"rates":"Rating_rates__dsgF4","star":"Rating_star__UIGut"};